export default __webpack_public_path__ + "static/1_3-fd5b3e275e3f84cc13c9b451a84104e2.png";